import request from "./request";


// 活动
export function getActivity() {
  return request({
    url: "/bjweb/content/index",
    method: "get",
  });
}

// 协议
export function agreementList(data) {
  return request({
    url: "/bjweb/sys/agreement",
    method: "post",
    data
  });
}

export function getWhois(params) {
  return request({
    url: "/bjweb/ym/getDomainWhois",
    method: "get",
    params
  });
}

//Whois查询
export function getCaptchaWhoisV1(domain) {
  return request(
      {
        url: `/bjweb/sys/captcha/whois/${domain}`,
        method: "get",
      },
      false
  );
}

//Whois查询
export function getCaptchaWhoisV2(domain, id, vCode) {
  return request(
      {
        url: `/bjweb/sys/captcha/whois/${domain}/${id}/${vCode}`,
        method: "get",
      },
      false
  );
}

// 域名后缀(二级)
export function getDomainSuffix() {
  return request({
    url: "/bjweb/ym/suf",
    method: "get",
  });
}

// 域名注册查询
export function searchDomain(data) {
  return request(
    {
      url: "/bjweb/ym/ck",
      method: "post",
      data,
    },
    true
  );
}

// 获取敏感词
export function sensitiveWords() {
  return request(
    {
      url: "/bjweb/ym/sensitiveWords",
      method: "post",
    },
    false
  );
}

//域名价格
export function getPriceList(type) {
  return request(
    {
      url: "/bjweb/ym/pr/" + type,
      method: "get",
    },
    false
  );
}

//加入购物车
export function addShopCart(data) {
  return request({
    url: "/bjweb/cart/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 查询模板
export function getTemplates(params) {
  return request({
    url: "/bjweb/domain/templates/getPage",
    params,
    method: "get",
    isToken: true,
  });
}

// 购物车查询
export function getShoppingCart(params) {
  return request({
    url: "/bjweb/cart/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// 购物车年限
export function orderCountEdit(data) {
  return request({
    url: "/bjweb/cart/year",
    data,
    method: "post",
    isToken: true,
  });
}

// 购物车删除
export function delectShopCart(data) {
  return request({
    url: "/bjweb/cart/delete",
    data,
    method: "DELETE",
    isToken: true,
  });
}

// 模板删除
export function delectTemplates(templateId) {
  return request({
    url: `/bjweb/domain/templates/delete/${templateId}`,
    method: "DELETE",
    isToken: true,
  });
}

// 创建订单
export function createOrder(data) {
  return request({
    url: "/bjweb/cart/order/save",
    data,
    method: "post",
    isToken: true,
  });
}

// 支付订单
export function pay(data) {
  return request({
    url: "/bjweb/pay",
    data,
    method: "post",
    isToken: true,
  });
}

// 获取支付订单
export function orderPayOrder(params) {
  return request({
    url: "/bjweb/order/pay/get",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名查询条件
export function domainQuery() {
  return request({
    url: "/bjweb/ym/qr",
    method: "get",
    isToken: true,
  });
}

// 域名品类
export function domainTypeList() {
  return request({
    url: "/bjweb/ym/str",
    method: "get",
    isToken: true,
  });
}

// 我的域名
export function domainList(params) {
  return request({
    url: "/bjweb/ym/my",
    params,
    method: "get",
    isToken: true,
  });
}

// 我的模板
export function templatesList(params) {
  return request({
    url: "/bjweb/domain/templates/getPage",
    params,
    method: "get",
    isToken: true,
  });
}

// 我的模板-根据模板查看域名列表
export function templatesDomainList(params) {
  return request({
    url: "/bjweb/domain/templates/one",
    params,
    method: "get",
    isToken: true,
  });
}

// 删除模板
export function deleteTemplate(params) {
  return request({
    method: "delete",
    url: `/bjweb/domain/templates/delete/${params}`,
    isToken: true,
  });
}

// 复制模板
export function getTemplateCopy(params) {
  return request({
    url: "/bjweb/domain/templates/cp",
    params,
    method: "get",
    isToken: true,
  });
}

// 获取邮箱，企业，个人认证
export function getcertifiedInformation() {
  return request({
    url: "/bjweb/renzhen/verifyInfo",
    method: "get",
    isToken: true,
  });
}

// 获取中国地区城市
export function getRegionList() {
  return request({
    url: "/bjweb/client/area",
    method: "get",
    isToken: true,
  });
}

// 查询默认模板
export function getTemplatesDefault() {
  return request({
    url: "/bjweb/domain/templates/default/info",
    method: "get",
    isToken: true,
  });
}

// 提交模板
export function templatesSave(data) {
  return request({
    url: "/bjweb/domain/templates/save",
    data, // post
    method: "post",
    isToken: true,
  });
}

// 提交默认模板
export function templatesDefaultSave(data) {
  return request({
    url: "/bjweb/domain/templates/default/save",
    params: data, // post query参数
    method: "post",
    isToken: true,
  });
}

// 模板过户
export function templatesTransfer(data) {
  return request({
    url: "/bjweb/domain/templates/push",
    data,
    method: "post",
    isToken: true,
  });
}

// 模板过户记录
export function getTemplatesTransferList(params) {
  return request({
    url: "/bjweb/domain/templates/pushList",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出记录
export function getTransferOutList(params) {
  return request({
    url: "/bjweb/domain/transferOut/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-重新索取转移码
export function transferOutRefreshCode(params) {
  return request({
    url: "/bjweb/domain/transferOut/code/new",
    params,
    method: "post",
    isToken: true,
  });
}

// 转出-取消转出
export function transferOutCancel(params) {
  return request({
    url: "/bjweb/domain/transferOut/cancel",
    params,
    method: "DELETE",
    isToken: true,
  });
}

// 转出-同意转出
export function transferOutConsent(data) {
  return request({
    url: "/bjweb/domain/transferOut/agree",
    data,
    method: "post",
    isToken: true,
  });
}

// 转出-查询状态
export function transferOutQueryStatus(params) {
  return request({
    url: "/bjweb/domain/transferOut/status",
    params,
    method: "get",
    isToken: true,
  });
}

// 转入记录
export function transferIntoList(params) {
  return request({
    url: "/bjweb/domain/transferInto/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// 转入-修改转移码
export function transferIntoEdit(data) {
  return request({
    url: "/bjweb/domain/transferInto/code/update",
    data,
    method: "post",
    isToken: true,
  });
}

// 转出-查询状态
export function transferIntoDetail(params) {
  return request({
    url: "/bjweb/domain/transferInto/status",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-检测域名
export function transferOutCheckDomain(params) {
  return request({
    url: "/bjweb/domain/transferOut/verify/dn",
    params,
    method: "get",
    isToken: true,
  });
}

// 转出-校验手机 step2
export function transferOutCheckMobile(data) {
  return request({
    url: "/bjweb/domain/transferOut/verify/code",
    data,
    method: "post",
    isToken: true,
  });
}

// 转出-获取转移码 step3
export function transferOutTransferCode(data) {
  return request({
    url: "/bjweb/domain/transferOut/getTransferCode",
    params: data, // post query参数
    method: "post",
    isToken: true,
  });
}

// 转入-保存
export function transferIntoSave(data) {
  return request({
    url: "/bjweb/domain/transferInto/save",
    data,
    method: "post",
    isToken: true,
  });
}

// PUSH-检测用户是否存在
export function userCheck(params) {
  return request({
    url: "/bjweb/client/check",
    params,
    method: "get",
    isToken: true,
  });
}

// 提交PUSH
export function pushCreate(data) {
  return request({
    url: "/bjweb/dn/push/save",
    data,
    method: "post",
    isToken: true,
  });
}

// PUSH-分页查询
export function pushPageList(params) {
  return request({
    url: "/bjweb/dn/push/getList",
    params,
    method: "get",
    isToken: true,
  });
}

// PUSH-操作
export function pushEdit(data) {
  return request({
    url: "/bjweb/dn/push/submit",
    data,
    method: "post",
    isToken: true,
  });
}

// 域名订单列表
export function orderPageList(params) {
  return request({
    url: "/bjweb/order/domain/get",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名订单-取消订单
export function orderCancel(data) {
  return request({
    url: "/bjweb/order/cancel",
    params: data,
    method: "post",
    isToken: true,
  });
}

// 域名订单-订单详情
export function orderDetail(params) {
  return request({
    url: "/bjweb/order/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 域名订单-订单详情
export function cartOrderDetail(params) {
  return request({
    url: "/bjweb/cart/order/detail",
    params,
    method: "get",
    isToken: true,
  });
}

// 设置隐私保护
export function domainSetPrivacy(data) {
  return request({
    url: `/bjweb/ym/protected`,
    data,
    method: "post",
    isToken: true,
  });
}

// 我的域名-自动续费
export function domainAutoRenew(data) {
  return request({
    url: `/bjweb/ym/renew/auto`,
    data,
    method: "post",
    isToken: true,
  });
}


// 例行维护公告
export function serverUpdate() {
  return request(
    {
      url: "/bjweb/content/serverUpdate",
      method: "post",
      isToken: true,
    }
  );
}
